<template>
  <h3 class="pb5">Cumulatif des visites par période (CDX_0293)</h3>
  <CritereRechercheClientMystere :onlyShowDate1="false" :onlyShowDate2="false" :onlyShowVagues="false"
                                 ref="critereRechercheClientMystere"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheClientMystere from "@/components/rapports/Rechercher/CritereRechercheClientMystere.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "VisitesClientMystereGenerateurRapport_CDX_293",
  components: {CritereRechercheClientMystere, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Client Mystère");
    this.isRechercheDataLoading = true;
    this.$store.dispatch("clientMystere/obtenirVaguesActivesAction")
        .then((res) => {
          this.assignerResultat(res);
          this.isRechercheDataLoading = false;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerResultat(res) {
      if (res.data !== null)
        this.$refs.critereRechercheClientMystere.assignerListe(res.data);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheClientMystere.getCriteresRecherche();
      criteresRecherche.titre = "VisitesClientMystereGenerateurRapport_CDX_293";
      criteresRecherche.nomRapport = "VisitesClientMystereGenerateurRapport_CDX_293";
      criteresRecherche.typeRapport = "Excel"
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>